export const addQuery = (history, location, key, value) => {
  let pathname = location.pathname;
  let searchParams = new URLSearchParams(location.search);
  key.forEach((param, index) => {
    searchParams.set(key[index], value[index]);
  });
  history.push({
    pathname: pathname,
    search: searchParams.toString(),
  });

  addTransactionFilterLocalStorage(searchParams.toString());
};

function removeParam(key, params) {
  let param,
    params_arr = [],
    queryString = params.indexOf("?") !== -1 ? params.split("?")[1] : "";
  if (queryString !== "") {
    params_arr = queryString.split("&");
    let arr = params_arr.filter((pa) => {
      param = pa.split("=")[0];
      return !key.includes(param);
    });
    params = arr ? arr.join("&") : "";
  }
  return params;
}

export const removeQuery = (history, location, key) => {
  let pathname = location.pathname;
  let params = removeParam(key, location.search);
  history.push({
    pathname: pathname,
    search: params.toString(),
  });
  addTransactionFilterLocalStorage(params.toString());
};

export const removeTransactionFilterFromLocalStorage = () => {
  localStorage.removeItem("transactionFilters");
};

export const addTransactionFilterLocalStorage = (data) => {
  localStorage.setItem("transactionFilters", data);
};

export const getTransactionFilterFromLocalStorage = () => {
  return localStorage.getItem("transactionFilters");
};
